// extracted by mini-css-extract-plugin
export default {"white":"#fff","disabledGrey":"#959da1"};